// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultipleSeriesChartComponent } from './components/multiple-series-chart/multiple-series-chart.component';
import { TranslateModule } from '@ngx-translate/core';
import { MultipleSeriesChartTooltipComponent } from '@coa/app/shared/multiple-series-chart/components/multiple-series-chart/multiple-series-chart-tooltip/multiple-series-chart-tooltip.component';
import { MultipleSeriesChartBackgroundComponent } from '@coa/app/shared/multiple-series-chart/components/multiple-series-chart-background/multiple-series-chart-background.component';


@NgModule({
  declarations: [
    MultipleSeriesChartComponent,
    MultipleSeriesChartTooltipComponent,
    MultipleSeriesChartBackgroundComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
  ],
  exports: [
    MultipleSeriesChartComponent,
    MultipleSeriesChartTooltipComponent,
    MultipleSeriesChartBackgroundComponent,
  ],
})
export class MultipleSeriesChartModule {
}
